var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchNoData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#search-no-data_svg__clip0_2568_22154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.624 14.393H23.957a1.52 1.52 0 00-1.519 1.519v39.265l-.202.062-4.334 1.327a.81.81 0 01-1.012-.538L4 13.919a.81.81 0 01.537-1.01l6.679-2.046 19.362-5.926 6.678-2.045a.809.809 0 011.012.536l3.295 10.764.062.202z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.479 14.19L41.507 1.219a1.72 1.72 0 00-2.15-1.142L29.969 2.95l-19.36 5.928-9.39 2.875a1.723 1.723 0 00-1.143 2.15L13.65 58.236a1.724 1.724 0 002.15 1.142l6.436-1.97.203-.062v-.212l-.203.062-6.496 1.99a1.52 1.52 0 01-1.896-1.008L.27 13.843a1.517 1.517 0 011.007-1.897l9.39-2.875 19.36-5.926L39.418.27a1.52 1.52 0 011.896 1.007l3.954 12.914.063.202h.21l-.061-.202z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.42 12.94a.913.913 0 01-.872-.644l-1.304-4.26a.91.91 0 01.605-1.137L28.66 1.445a.912.912 0 011.138.605l1.304 4.26a.912.912 0 01-.604 1.137L12.686 12.9a.91.91 0 01-.266.04z",
    fill: "#00BFA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.25 4.551a2.025 2.025 0 100-4.05 2.025 2.025 0 000 4.05z",
    fill: "#00BFA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.25 3.808a1.282 1.282 0 100-2.564 1.282 1.282 0 000 2.564zM61.01 58.938H26.79a.862.862 0 01-.86-.86V17.075a.861.861 0 01.86-.86H61.01a.861.861 0 01.86.86v41.002a.862.862 0 01-.86.86z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.267 14.19h-21.31a1.724 1.724 0 00-1.722 1.722v41.285l.203-.062V15.912a1.52 1.52 0 011.518-1.519H45.33l-.063-.202zm18.577 0H23.956a1.724 1.724 0 00-1.72 1.722v46.367A1.723 1.723 0 0023.955 64h39.888a1.723 1.723 0 001.721-1.721V15.912a1.723 1.723 0 00-1.72-1.721zm1.519 48.089a1.52 1.52 0 01-1.519 1.518H23.956a1.52 1.52 0 01-1.518-1.518V15.912a1.52 1.52 0 011.518-1.519h39.888a1.52 1.52 0 011.519 1.519v46.367z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.214 18.645H34.586a.912.912 0 01-.91-.91V13.28a.912.912 0 01.91-.911h18.628a.912.912 0 01.911.91v4.455a.912.912 0 01-.91.911z",
    fill: "#00BFA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9 12.672a2.025 2.025 0 100-4.05 2.025 2.025 0 000 4.05z",
    fill: "#00BFA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9 11.88a1.233 1.233 0 100-2.466 1.233 1.233 0 000 2.467z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "search-no-data_svg__clip0_2568_22154"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h65.565v64H0z"
  })))));
}
export default SvgSearchNoData;